/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const xngPopulateApiParameter: any = (props: any) => {
    if ("apiParameter" in props.parameter) {
        props.apiParameter = props.parameter.apiParameter;
        return;
    }

    props.apiParameter = {
        cartId: props.parameter.cartId,
        expand: ["validation"],
    };

    if (props.needFullCart) {
        const pageType = getCurrentPage(props.getState()).type;
        const cartSettings = props.getState().context.settings.settingsCollection.cartSettings;

        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [...(props.apiParameter.expand || []), "cartLines", "restrictions", "properties"];

        if (cartSettings.showTaxAndShipping || pageType !== "CartPage") {
            props.apiParameter.expand.push("shipping", "tax");
        }

        if (!props.parameter.dontExpandFull) {
            props.apiParameter.expand = [
                ...(props.apiParameter.expand || []),
                "shipping",
                "tax",
                "carriers",
                "paymentOptions",
                "creditCardBillingAddress",
            ];
        }

        props.apiParameter.time = new Date();
    }
};

replaceInChain(chain, PopulateApiParameter, xngPopulateApiParameter);
